export default __webpack_public_path__ + "static/media/SuperToDo5.643d0fe8.jpg";